// import React from "react";
// import { Toaster } from "react-hot-toast";
// import { AuthProvider, useAuth } from "./context/AuthContext";
// import LoginPage from "./pages/LoginPage";
// import Dashboard from "./pages/Dashboard";
// import "./App.css";

// function AppInner() {
//   const { user, loading } = useAuth();
//   if (loading) return <div className="app-loading"><div className="spinner" /></div>;
//   return user ? <Dashboard /> : <LoginPage />;
// }

// export default function App() {
//   return (
//     <AuthProvider>
//       <Toaster
//         position="top-right"
//         toastOptions={{
//           style: { background: "#1e1e2e", color: "#cdd6f4", border: "1px solid #313244" },
//           success: { iconTheme: { primary: "#a6e3a1", secondary: "#1e1e2e" } },
//           error:   { iconTheme: { primary: "#f38ba8", secondary: "#1e1e2e" } },
//         }}
//       />
//       <AppInner />
//     </AuthProvider>
//   );
// }












import React from "react";
import { Toaster } from "react-hot-toast";
import { AuthProvider, useAuth } from "./context/AuthContext";
import LoginPage from "./pages/LoginPage";
import Dashboard from "./pages/Dashboard";
import "./App.css";

function AppInner() {
  const { user, loading } = useAuth();
  if (loading) return <div className="app-loading"><div className="spinner" /></div>;
  return user ? <Dashboard /> : <LoginPage />;
}

export default function App() {
  return (
    <AuthProvider>
      <Toaster
        position="top-center"
        containerStyle={{
          top: "50%",
          transform: "translateY(-50%)",
        }}
        toastOptions={{
          duration: 3000,
          style: {
            background: "#1e1e2e",
            color: "#cdd6f4",
            border: "1px solid #313244",
            padding: "16px 22px",
            fontSize: "14px",
            fontWeight: 500,
            borderRadius: "12px",
            boxShadow: "0 12px 40px rgba(0,0,0,.35)",
          },
          success: { iconTheme: { primary: "#a6e3a1", secondary: "#1e1e2e" } },
          error:   { iconTheme: { primary: "#f38ba8", secondary: "#1e1e2e" } },
        }}
      />
      <AppInner />
    </AuthProvider>
  );
}
